/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ScholarshipfileapprovalCoursefinancialpersonid200,
  GetApiV1ScholarshipfileapprovalCoursefinancialpersonid400,
  GetApiV1ScholarshipfileapprovalCoursefinancialpersonid401,
  GetApiV1ScholarshipfileapprovalCoursefinancialpersonid404,
  GetApiV1ScholarshipfileapprovalCoursefinancialpersonid500,
  GetApiV1ScholarshipfileapprovalCoursefinancialpersonidPathParams,
  GetApiV1ScholarshipfileapprovalCoursefinancialpersonidQueryParams,
  GetApiV1ScholarshipfileapprovalCoursefinancialpersonidQueryResponse,
} from "../../types/scholarshipTypeFileApprovalController/GetApiV1ScholarshipfileapprovalCoursefinancialpersonid.ts";
import { scholarshipFileApprovalDossierViewModelSchema } from "../scholarshipFileApprovalDossierViewModelSchema.ts";

export const getApiV1ScholarshipfileapprovalCoursefinancialpersonidPathParamsSchema =
  z.object({
    courseFinancialPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ScholarshipfileapprovalCoursefinancialpersonidPathParams>;

export const getApiV1ScholarshipfileapprovalCoursefinancialpersonidQueryParamsSchema =
  z.object({
    culture: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1ScholarshipfileapprovalCoursefinancialpersonidQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ScholarshipfileapprovalCoursefinancialpersonid200Schema =
  z.lazy(
    () => scholarshipFileApprovalDossierViewModelSchema,
  ) as unknown as ToZod<GetApiV1ScholarshipfileapprovalCoursefinancialpersonid200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ScholarshipfileapprovalCoursefinancialpersonid400Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshipfileapprovalCoursefinancialpersonid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ScholarshipfileapprovalCoursefinancialpersonid401Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshipfileapprovalCoursefinancialpersonid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ScholarshipfileapprovalCoursefinancialpersonid404Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshipfileapprovalCoursefinancialpersonid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ScholarshipfileapprovalCoursefinancialpersonid500Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshipfileapprovalCoursefinancialpersonid500>;

export const getApiV1ScholarshipfileapprovalCoursefinancialpersonidQueryResponseSchema =
  z.lazy(
    () => getApiV1ScholarshipfileapprovalCoursefinancialpersonid200Schema,
  ) as unknown as ToZod<GetApiV1ScholarshipfileapprovalCoursefinancialpersonidQueryResponse>;
